import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/AdminLogin";
import Dashboard from "@/pages/Dashboard";
import QuoteBuilder from "@/pages/QuoteBuilder";
import AdminSettings from "@/pages/AdminSettings";
import CustomerQuote from "@/pages/CustomerQuote";
import RealtorList from "@/pages/RealtorList";
import RealtorNew from "@/pages/RealtorNew";
import RealtorDetail from "@/pages/RealtorDetail";
import PartnerFunnel from "@/pages/PartnerFunnel";
import PartnerPresentation from "@/pages/PartnerPresentation";
import ClientRevival from "@/pages/ClientRevival";
import TrackRedirect from "@/pages/TrackRedirect";
import Landing from "@/pages/Landing";
import LeadsList from "@/pages/LeadsList";
import LeadDetail from "@/pages/LeadDetail";
import FunnelAnalytics from "@/pages/FunnelAnalytics";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-2 border-black border-t-[#c19a6b] rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin/leads" element={<Protected><LeadsList /></Protected>} />
            <Route path="/admin/leads/:id" element={<Protected><LeadDetail /></Protected>} />
            <Route path="/admin/analytics" element={<Protected><FunnelAnalytics /></Protected>} />
            <Route path="/admin/quotes/new" element={<Protected><QuoteBuilder /></Protected>} />
            <Route path="/admin/quotes/:id" element={<Protected><QuoteBuilder /></Protected>} />
            <Route path="/admin/settings" element={<Protected><AdminSettings /></Protected>} />
            <Route path="/admin/realtors" element={<Protected><RealtorList /></Protected>} />
            <Route path="/admin/realtors/new" element={<Protected><RealtorNew /></Protected>} />
            <Route path="/admin/realtors/:id" element={<Protected><RealtorDetail /></Protected>} />
            <Route path="/admin/partner-funnel" element={<Protected><PartnerFunnel /></Protected>} />
            <Route path="/quote/:token" element={<CustomerQuote />} />
            <Route path="/partners/:slug" element={<PartnerPresentation />} />
            <Route path="/revival/:slug" element={<ClientRevival />} />
            <Route path="/r/:code" element={<TrackRedirect />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
